import React from 'react';
import { Outlet, NavLink, Navigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import useAuthStore from '@/store/authStore';
import { LayoutDashboard, Users, Package, ShieldCheck, ScrollText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const AdminLayout = () => {
  const { user } = useAuthStore();
  
  if (!user?.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  const navigation = [
    { name: 'Overview', to: '/dashboard/admin', end: true, icon: LayoutDashboard, testId: 'admin-nav-overview' },
    { name: 'Users', to: '/dashboard/admin/users', icon: Users, testId: 'admin-nav-users' },
    { name: 'Applications', to: '/dashboard/admin/apps', icon: Package, testId: 'admin-nav-apps' },
    { name: 'OAuth Providers', to: '/dashboard/admin/providers', icon: ShieldCheck, testId: 'admin-nav-providers' },
    { name: 'Audit Logs', to: '/dashboard/admin/audit', icon: ScrollText, testId: 'admin-nav-audit' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-3 mb-1">
            <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-pista/20 text-pista border border-pista/30">
              ADMIN
            </span>
            <h2 className="text-3xl font-bold tracking-tight">Admin Panel</h2>
          </div>
          <p className="text-muted-foreground text-sm">Manage the LostDrkC Identity Platform</p>
        </div>
        <Link to="/dashboard">
          <Button variant="outline" size="sm" data-testid="back-to-dashboard-button">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </Link>
      </div>

      <Card className="p-1">
        <nav className="flex flex-wrap gap-1" data-testid="admin-nav">
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center px-4 py-2 rounded-md transition-colors duration-200 text-sm font-medium ${
                  isActive
                    ? 'bg-pista text-primary-foreground'
                    : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                }`
              }
              data-testid={item.testId}
            >
              <item.icon className="h-4 w-4 mr-2" />
              {item.name}
            </NavLink>
          ))}
        </nav>
      </Card>

      <Outlet />
    </div>
  );
};

export default AdminLayout;
